import { useEffect, useState } from "react";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { initLenis } from "@/lib/scroll";
import Nav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import SocialProof from "@/components/landing/SocialProof";
import Marquee from "@/components/landing/Marquee";
import Comparison from "@/components/landing/Comparison";
import Pricing from "@/components/landing/Pricing";
import Faq from "@/components/landing/Faq";
import Booking from "@/components/landing/Booking";
import Contact from "@/components/landing/Contact";
import Footer from "@/components/landing/Footer";
import PaymentResult from "@/components/landing/PaymentResult";

export default function App() {
  const [selectedPlan, setSelectedPlan] = useState("Croissance & Sérénité");
  const path = window.location.pathname;

  useEffect(() => {
    initLenis();
  }, []);

  if (path.startsWith("/payment/")) {
    return (
      <div className="min-h-screen bg-[#070A0F] text-gray-100">
        <PaymentResult kind={path.includes("success") ? "success" : "cancel"} />
        <Toaster theme="dark" position="bottom-right" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#070A0F] text-gray-100">
      <Nav />
      <main>
        <Hero />
        <SocialProof />
        <Marquee />
        <Comparison />
        <Pricing onSelectPlan={setSelectedPlan} />
        <Faq />
        <Booking />
        <Contact selectedPlan={selectedPlan} setSelectedPlan={setSelectedPlan} />
      </main>
      <Footer />
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}
